module.exports = __webpack_public_path__ + "static/media/GameChanger.c97cf41d.svg";